<template>
  <div class="d-flex table-container">
    <table class="mark-table">
      <thead>
        <tr>
          <th rowspan="2">STT</th>
          <!-- <th rowspan="2">Học phần</th> -->
          <th rowspan="2">Học viên</th>
          <th rowspan="2">Ngày sinh</th>
          <th
            :class="{ 'semseter-header': gradeClassMark.isGroup }"
            v-for="gradeClassMark in headers"
            :key="gradeClassMark.id"
            :colspan="gradeClassMark.maxCol"
          >
            <div v-if="gradeClassMark.isGroup">{{ gradeClassMark.title }}</div>
            <div v-else>
              {{ gradeClassMark.title }}
              <br />
              (HS {{ gradeClassMark.factor }})
            </div>
          </th>
          <th>Tổng kết</th>
        </tr>
        <tr v-if="groups.length">
          <td v-for="gradeClassMark in singles" :key="gradeClassMark.id" :colspan="gradeClassMark.maxCol">
            <div v-if="gradeClassMark.parent">
              {{ gradeClassMark.title }}
              <br />
              (HS {{ gradeClassMark.factor }})
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, order) in studentWithMark" :key="item.id">
          <td>{{ order + 1 }}</td>
          <td class="px-2 py-0" style="text-align: left"><CardStudentName :student="item.student" link /></td>
          <td>{{ item.student.dob | ddmmyyyy }}</td>
          <!-- <td>{{ `${get(item, 'student.classes.grade.name')} - ${get(item, 'student.classes.grade.code')}` }}</td> -->

          <td v-for="mark in item.marks" :key="mark.id">
            <span v-if="mark.type === 'total'">{{ mark.score }}</span>
            <v-tooltip v-else bottom>
              <template v-slot:activator="{ on, attrs }">
                <div style="width: 40px">
                  <span v-bind="attrs" v-on="on">
                    {{ mark.score }}
                  </span>
                </div>
              </template>
              <span>Cập nhật lần cuối {{ mark.updatedAt | ddmmyyyy }}</span>
            </v-tooltip>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import get from 'lodash-es/get'

export default {
  components: { CardStudentName },
  data() {
    return {
      get,
    }
  },
  props: {
    groups: Array,
    singles: Array,
    studentWithMark: Array,
    headers: Array,
  }
}
</script>

<style lang="scss" scoped>
.mark-table {
  td,
  tr,
  th {
    border: 1px solid #e0e0e0;
  }
  td,
  th {
    padding: 14px 20px;
    text-align: center;
  }
  .semseter-header {
    font-size: 20px;
    // color: #0d47a1;
    text-transform: uppercase;
  }
  color: #212121;
  border-collapse: collapse;
  width: 100%;
}
.table-container {
  overflow: auto;
  max-width: 100%;
}
</style>
